function hasValue(value) {
  if (typeof value === 'string') {
    return value.trim().length > 0
  }

  return value !== null && value !== undefined
}

export function hasQuestionAnswer(answer) {
  if (!answer || typeof answer !== 'object') {
    return false
  }

  const hasContent = hasValue(answer.content)
  const hasArrayContent = Array.isArray(answer.contentArray) &&
      answer.contentArray.some(hasValue)
  const hasUploadedFile = hasValue(answer.userAnswerFileId)

  return hasContent || hasArrayContent || hasUploadedFile
}

export async function loadQuestionData(id, loadDetail, loadAnalysis) {
  try {
    return await loadDetail(id, { suppressErrorMessage: true })
  } catch (error) {
    return loadAnalysis(id, { suppressErrorMessage: true })
  }
}

export function revealQuestionAnalysis(page) {
  page.showAnalysis = true
  page.$nextTick(() => {
    const analysisCard = page.$refs.analysisCard
    if (analysisCard && analysisCard.$el) {
      analysisCard.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  })
}

export function completeQuestionSubmission(page, result) {
  const isIncorrect = String(result).includes('错误')
  page.$message({
    type: isIncorrect ? 'error' : 'success',
    message: `本次答题结果：${result}`
  })
  revealQuestionAnalysis(page)
}
